"use client";

import { ChevronDown, Share } from "lucide-react";
import { useTranslations } from "next-intl";

import { SocialIcon } from "@/components/frontend/ui/icons/social";
import { createSocialShareItems } from "@/lib/social/platforms";
import Menu, { MenuItem } from "@/components/frontend/ui/menu";
import { Button } from "@/components/frontend/ui/button";

interface PropertyShareDropdownProps {
	label: string;
	title: string;
	url: string;
}

export const PropertyShareDropdown: React.FC<PropertyShareDropdownProps> = ({ label, title, url }) => {
	const t = useTranslations("social");
	const items = createSocialShareItems(url, title, {
		twitter: t("shareOnTwitter"),
		facebook: t("shareOnFacebook"),
		linkedin: t("shareOnLinkedIn"),
		email: t("shareByEmail"),
		whatsapp: t("shareOnWhatsApp"),
	});

	return (
		<Menu
			trigger={
				<Button nativeButton={false}>
					<Share className="size-4" />
					{label}
					<span className="transition-transform duration-200 ease-in-out group-data-popup-open:rotate-180">
						<ChevronDown className="size-4" />
					</span>
				</Button>
			}
		>
			{items.map(({ key, label, href, external }) => (
				<MenuItem
					key={key}
					href={href}
					target={external ? "_blank" : undefined}
					rel={external ? "noopener noreferrer" : undefined}
					className="hover:bg-[color-mix(in_srgb,var(--ms-card-background-color)_95%,black)] cursor-pointer rounded-(--ms-card-border-bottom-left-radius) px-[calc(var(--ms-card-padding-left)/1.2)] py-[calc(var(--ms-card-padding-top)/1.2)] flex items-center gap-2 text-nowrap"
				>
					<SocialIcon platform={key} className="size-4" />
					{label}
				</MenuItem>
			))}
		</Menu>
	);
};
